import React from 'react'
import PackageComponent from '../../Package'
import {  Category_TopTrend, } from '../../../utils/formatType'

export default function TopTrendCategory() {
  return (
    <div>
            <PackageComponent title="Top xu hướng" packageId={Category_TopTrend} />

    </div>
  )
}
